import React from 'react';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    message,
    confirmText = "Confirm",
    confirmColor = "bg-red-600",
    isProcessing = false,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-70 backdrop-blur-sm">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
                {/* Modal Container */}
                <div className="bg-white dark:bg-brand-black rounded-xl shadow-2xl p-6 w-full max-w-sm text-left border dark:border-brand-gray/30 transition-colors duration-500">
                    
                    <h3 className="text-lg font-bold text-gray-900 dark:text-brand-white">
                        {title}
                    </h3>
                    
                    <div className="mt-2">
                        <p className="text-sm text-gray-600 dark:text-brand-gray">
                            {message}
                        </p>
                    </div>

                    <div className="mt-6 flex justify-end gap-4">
                        {/* Cancel Button */}
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={isProcessing}
                            className="px-4 py-2 text-sm font-semibold text-gray-700 dark:text-brand-gray bg-gray-100 dark:bg-brand-gray/20 rounded-md hover:bg-gray-200 dark:hover:bg-brand-gray/30 transition-colors"
                        >
                            Cancel
                        </button>

                        {/* Confirm Button */}
                        <button
                            type="button"
                            onClick={onConfirm}
                            disabled={isProcessing}
                            className={`px-4 py-2 text-sm font-semibold text-white rounded-md transition-all active:scale-95 ${confirmColor} hover:brightness-110 disabled:bg-brand-gray`}
                        >
                            {isProcessing ? "Processing..." : confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;